import React, { useEffect, useRef } from 'react';
import styled, { css, keyframes } from 'styled-components';

import {
    TOAST_HIDE_AFTER_EXPIRATION,
    TOAST_HIDE_DURATION,
    TOAST_SHOW_DURATION,
    TOAST_SLIDE_DURATION,
} from '@r1-frontend/ui-react/experimental/Toaster/constants';
import getStartPositionByDirection from '@r1-frontend/ui-react/experimental/Toaster/helpers/getStartPositionByDirection';
import { TToast, TToastDirection } from '@r1-frontend/ui-react/experimental/Toaster/types';

const Toast = (
    {
        id,
        children,
        permanent,
        removeHandler = () => true,
        ...props
    }: TToast & { removeHandler?: (id: string) => void },
): JSX.Element => {
    const toastRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        (async() => {
            if (toastRef !== null && toastRef.current !== null && !permanent) {
                await Promise.allSettled(
                    toastRef.current.getAnimations().map(animation => animation.finished),
                );
                removeHandler(id);
            }
        })();
    }, [toastRef, permanent]);

    return <div ref={toastRef} {...props}>
        {children}
    </div>;
};

const fadeIn = keyframes`
    from {
        opacity: 0;
    }
`;

const fadeOut = keyframes`
    to {
        opacity: 0;
    }
`;

const StyledToast = styled(Toast)<{ direction: TToastDirection, permanent: boolean }>`
    display: inline-block;

    ${({ permanent = false }) => permanent
        ? css`
            animation: ${fadeIn} ${TOAST_SHOW_DURATION}s ease,
            ${getStartPositionByDirection} ${TOAST_SLIDE_DURATION}s ease;
        `
        : css`
            animation: ${fadeIn} ${TOAST_SHOW_DURATION}s ease,
            ${getStartPositionByDirection} ${TOAST_SLIDE_DURATION}s ease,
            ${fadeOut} ${TOAST_HIDE_DURATION}s ease ${TOAST_HIDE_AFTER_EXPIRATION}s;
        `
    }
`;
export default StyledToast;
